import { Button } from '@components/v2/ui';
import { Title } from '@components/v2/ui/Title';
import { useOffsetCreation } from '@features/offsets/hooks/useOffsetCreation';
import { TMesurabilityProject } from '@features/offsets/types';
import { Box } from '@mantine/core';
import { t } from 'i18next';
import { WarningAlert } from '../WarningAlert/WarningAlert';
import { FinalOffsetSummary } from './FinalOffsetSummary';
import classes from './FinalOffsetSummaryCart.module.css';

const FinalOffsetSummaryCart = ({
	quantityOffset,
	offsetMesurabilityProjectsSelected,
}: {
	quantityOffset: number;
	offsetMesurabilityProjectsSelected: TMesurabilityProject[];
}) => {
	const { handleConfirmCreateOffset, isLoading } =
		useOffsetCreation();

	return (
		<Box className={classes.container}>
			<Title order={6} c={'#1D3965'}>
				{t('global.total')}
			</Title>

			<FinalOffsetSummary
				quantityOffset={quantityOffset}
				offsetMesurabilityProjectsSelected={
					offsetMesurabilityProjectsSelected
				}
			/>
			<WarningAlert
				description={t('global.warningCreationOffset')}
			/>
			<Button
				onClick={handleConfirmCreateOffset}
				fullWidth
				variant={'primary'}
				loading={isLoading}
				mt={'24px'}
			>
				{t('global.finalizeContribution')}
			</Button>
		</Box>
	);
};

export default FinalOffsetSummaryCart;
